import {
  Tooltip as HeroTooltip,
  type TooltipProps as HeroTooltipProps,
} from "@heroui/react";
import { useControlledState } from "@react-stately/utils";
import { useMemo } from "react";

export type TooltipProps = HeroTooltipProps;

export function Tooltip({
  closeDelay,
  delay,
  isOpen: isOpenProp,
  onOpenChange,
  ...props
}: TooltipProps) {
  const [isOpen, setIsOpen] = useControlledState(
    isOpenProp,
    false,
    onOpenChange,
  );

  const isControlled = isOpenProp !== undefined;

  const tooltipProps: HeroTooltipProps = useMemo(() => {
    if (isControlled) {
      return {
        ...props,
        closeDelay: closeDelay ?? 0,
        delay: delay ?? 0,
        isOpen,
        onOpenChange: setIsOpen,
      };
    }
    return {
      ...props,
      closeDelay,
      delay,
    };
  }, [closeDelay, delay, isControlled, isOpen, props, setIsOpen]);

  return <HeroTooltip {...tooltipProps} />;
}

Tooltip.displayName = "RecareUI.Tooltip";
